var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgTrash({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3.33337 5.83333H16.6667M8.33337 9.16667V14.1667M11.6667 9.16667V14.1667M4.16671 5.83333L5.00004 15.8333C5.00004 16.2754 5.17564 16.6993 5.4882 17.0118C5.80076 17.3244 6.22468 17.5 6.66671 17.5H13.3334C13.7754 17.5 14.1993 17.3244 14.5119 17.0118C14.8244 16.6993 15 16.2754 15 15.8333L15.8334 5.83333M7.50004 5.83333V3.33333C7.50004 3.11232 7.58784 2.90036 7.74412 2.74408C7.9004 2.5878 8.11236 2.5 8.33337 2.5H11.6667C11.8877 2.5 12.0997 2.5878 12.256 2.74408C12.4122 2.90036 12.5 3.11232 12.5 3.33333V5.83333",
    stroke: "#DA0D29",
    strokeWidth: 1.66667,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTrash);
export default __webpack_public_path__ + "static/media/trash.564f59f60c327ba2ce9fa2fc62297101.svg";
export { ForwardRef as ReactComponent };